import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const JobDetailsCard = ({ job }) => {
  return (
    <div className="bg-card border border-border rounded-lg p-6 mb-6">
      <div className="flex items-start gap-4">
        <div className="w-16 h-16 rounded-lg overflow-hidden flex-shrink-0 bg-muted">
          <Image
            src={job?.companyLogo}
            alt={job?.companyLogoAlt}
            className="w-full h-full object-cover"
          />
        </div>

        <div className="flex-1 min-w-0">
          <h2 className="text-xl font-semibold text-foreground mb-1">{job?.title}</h2>
          <p className="text-sm text-muted-foreground mb-3">{job?.company}</p>

          <div className="flex flex-wrap items-center gap-4 text-sm text-muted-foreground">
            <div className="flex items-center gap-1">
              <Icon name="MapPin" size={16} />
              <span>{job?.location}</span>
            </div>
            <div className="flex items-center gap-1">
              <Icon name="Briefcase" size={16} />
              <span>{job?.type}</span>
            </div>
            <div className="flex items-center gap-1">
              <Icon name="IndianRupee" size={16} />
              <span>{job?.salary}</span>
            </div>
            <div className="flex items-center gap-1">
              <Icon name="Clock" size={16} />
              <span>{job?.experience}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default JobDetailsCard;